import { DEBUG_MODE } from './config'
import { translate } from './language'

export function getAttribution(
  attributed: string,
  date: string,
  selectedLanguage: any,
  withBreak :boolean
): JSX.Element {
  let ret: JSX.Element = <></>
  try {
    if (DEBUG_MODE) console.log(withBreak)
    ret = (
      <>
        <span
          style={{
            fontSize: '12px',
            fontWeight: 'normal',
            fontStyle: 'italic',
            color: 'rgba(255,255,255,0.6)',
            display: 'inline-block',
            paddingTop: '10px',
          }}
        >
          {translate(
            <>By&nbsp;</>,
            <>Por&nbsp;</>,
            <>Par&nbsp;</>,
            <></>,
            selectedLanguage
          )}
          {attributed}, {date}
        </span>
      </>
    )
  } catch (e) {
    if (DEBUG_MODE) console.log(e)
  }
  return ret
}
